import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgGpsFixedOff = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M13 20.945A9.004 9.004 0 0 0 20.945 13H22a1 1 0 1 0 0-2h-1.055A9.004 9.004 0 0 0 13 3.055V2a1 1 0 1 0-2 0v1.055A9.004 9.004 0 0 0 3.055 11H2a1 1 0 1 0 0 2h1.055A9.004 9.004 0 0 0 11 20.945V22a1 1 0 1 0 2 0v-1.055ZM5 12a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z" />
  )
export default SvgGpsFixedOff
